<ng-container *ngIf="alert">
    <button
        nz-button
        nz-dropdown
        [nzDropdownMenu]="alertsMenu"
        nzTrigger="click"
        [nzType]="size === 'small' ? 'text' : 'default'"
        [nzSize]="size"
        class="a-fx a-fx-center-center"
    >
        <svg class="adspt-icon">
            <use xlink:href="#adspt-ellipsis-horizontal"></use>
        </svg>
    </button>

    <nz-dropdown-menu #alertsMenu="nzDropdownMenu">
        <ul nz-menu>
            <li nz-menu-item [ngSwitch]="!!alert.cleared" (click)="toggleAlertResolved(alert)">
                <ng-container *ngSwitchCase="false">
                    {{ 'alert-center.instance.mark-as-resolved' | translate }}
                </ng-container>

                <ng-container *ngSwitchCase="true">
                    {{ 'alert-center.instance.mark-as-unresolved' | translate }}
                </ng-container>
            </li>

            <li nz-menu-item [ngSwitch]="!!alert.read" (click)="toggleAlertRead(alert)">
                <ng-container *ngSwitchCase="false">
                    {{ 'alert-center.instance.mark-as-read' | translate }}
                </ng-container>

                <ng-container *ngSwitchCase="true">
                    {{ 'alert-center.instance.mark-as-unread' | translate }}
                </ng-container>
            </li>

            <ng-container *ngIf="alert.severity !== AlertSeverity.Critical">
                <nz-divider></nz-divider>

                <li nz-menu-item (click)="muteAlert(alert, 'mute-week')">
                    {{ 'alert-center.mute-menu.mute-week' | translate }}
                </li>

                <li nz-menu-item (click)="muteAlert(alert, 'mute-month')">
                    {{ 'alert-center.mute-menu.mute-month' | translate }}
                </li>

                <li nz-menu-item (click)="muteAlert(alert, 'mute-indef')">
                    {{ 'alert-center.mute-menu.mute-indef' | translate }}
                </li>
            </ng-container>
        </ul>
    </nz-dropdown-menu>
</ng-container>
